var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_7965_157946)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M35.5 71C55.1061 71 71 55.1061 71 35.5C71 15.8939 55.1061 0 35.5 0C15.8939 0 0 15.8939 0 35.5C0 55.1061 15.8939 71 35.5 71Z",
  fill: "url(#paint0_radial_7965_157946)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_7965_157946)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33.1911 18.5658C32.8209 18.9378 32.5491 19.3902 32.3926 19.8823L22.3633 46.5966H18.3181V50.694H25.9792L28.9313 42.5462L30.3363 38.4502L35.4436 23.9463L44.8627 50.694H52.6805V46.5966H48.6196L38.5912 19.8814C38.4347 19.3898 38.1629 18.9375 37.7928 18.5658C37.1827 17.9525 36.355 17.608 35.492 17.608C34.6289 17.608 33.8014 17.9525 33.1911 18.5658Z",
  fill: "white"
})));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_7965_157946",
  x: 14.3181,
  y: 17.608,
  width: 42.3625,
  height: 41.086,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_7965_157946"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_7965_157946",
  result: "shape"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_7965_157946",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "rotate(45) scale(100.409 67.5128)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#79A5C6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.616783,
  stopColor: "#2A4874"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_7965_157946"
}, /*#__PURE__*/React.createElement("rect", {
  width: 71,
  height: 71,
  fill: "white"
})));
function SvgLif3Coin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLif3Coin);
export default __webpack_public_path__ + "static/media/lif3_coin.2c5be6515cdcd57412bfd2302162ac23.svg";
export { ForwardRef as ReactComponent };